import { Button } from "@circle-react-shared/uikit/Button";
import { Modal } from "@circle-react-shared/uikit/ModalV2";
import { Typography } from "@circle-react-shared/uikit/Typography";
import {
  ModalManager,
  useModal,
} from "@circle-react/components/Layout/ModalManagerProvider";
import { useState } from "react";

import { t } from "@/i18n-js/instance";
import { usePunditUserContext } from "@/react/contexts/punditUserContext";

import { useV4Activation } from "../ActivationConfirmationModal/useV4Activation";
import { ACTIVATION_LOADING_MIN_DURATION_MS } from "../constants";
import { dismissEclipseReadyModal } from "./dismissal";

const i18nRoot = "eclipse_ready_modal";

export const EclipseReadyModalComponent = () => {
  const modal = useModal();
  const { currentCommunity } = usePunditUserContext();
  const [isEnablingPreview, setIsEnablingPreview] = useState(false);
  const { mutate: enablePreview } = useV4Activation({
    showPreviewModal: true,
    showActivationLoadingScreen: true,
    redirectTo: "/ai",
    minimumLoadingDurationMs: ACTIVATION_LOADING_MIN_DURATION_MS,
    onError: () => setIsEnablingPreview(false),
  });

  const dismiss = () => {
    if (currentCommunity?.id) {
      dismissEclipseReadyModal(currentCommunity.id);
    }

    void modal.hide();
    modal.remove();
  };

  const handlePreview = () => {
    setIsEnablingPreview(true);
    enablePreview();
  };

  const handleClose = () => {
    if (!isEnablingPreview) {
      dismiss();
    }
  };

  return (
    <Modal isOpen={modal.visible} onClose={handleClose}>
      <Modal.Overlay />
      <Modal.Content size="lg">
        <Modal.Header>
          <Modal.Title>{t([i18nRoot, "title"])}</Modal.Title>
          <Modal.HeaderActions>
            <Modal.CloseButton onClick={handleClose} />
          </Modal.HeaderActions>
        </Modal.Header>
        <Modal.Body>
          <div className="flex flex-col gap-4">
            <Typography.BodyMd color="text-default">
              <strong>{t([i18nRoot, "description_lead"])}</strong>
            </Typography.BodyMd>
            <Typography.BodyMd color="text-default">
              {t([i18nRoot, "description_details"])}
            </Typography.BodyMd>
            <hr className="border-primary" />
            <Typography.BodyMd color="text-default">
              <strong>
                {"→ "}
                {t([i18nRoot, "included_with_plan"])}
              </strong>{" "}
              {t([i18nRoot, "preview_explanation"])}
            </Typography.BodyMd>
            <Typography.BodyMd color="text-default">
              <strong>
                {"→ "}
                {t([i18nRoot, "recommendation"])}
              </strong>{" "}
              {t([i18nRoot, "automatic_activation"])}
            </Typography.BodyMd>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="flex justify-end">
            <Button
              type="button"
              variant="circle"
              onClick={handlePreview}
              disabled={isEnablingPreview}
            >
              {t([i18nRoot, "preview_as_admin"])}
            </Button>
          </div>
        </Modal.Footer>
      </Modal.Content>
    </Modal>
  );
};

const EclipseReadyModal = ModalManager.create(() => (
  <EclipseReadyModalComponent />
));

export const useEclipseReadyModal = () => useModal(EclipseReadyModal);
